import React from 'react';
import RadioPage from '@domain/pages/RadioPage';

const driveableDamage = 'driveableDamage';
function DriveableDamage() {

  const fields = [{
    id: 1,
    value: 'yes',
    triggerKeys: [106, 74, 49],
    label: 'Ja'
  }, {
    id: 2,
    value: 'no',
    triggerKeys: [110, 78, 50],
    label: 'Nee'
  }
  ]

  return <RadioPage fieldName={driveableDamage} styleLabel={'driveable-damage'} fields={fields} />
}

export default DriveableDamage;
